var e4 = e4 || {},
    canett = canett || {};
( function () {
    'use strict';
    jQuery( function () {
        canett.init();
    } );

    canett.init = function () {
        canett.items.inspiration.init();
        canett.loadMore.init();
        canett.lottie.init();
        canett.hassub.init();
        // canett.urlModel.init();
    };

    canett.loadMore = {
        init: function () {
            if (jQuery('#loadMore').length) {
                jQuery('.js-moreBox').slice(0, 4).show();
                if (jQuery('.js-blogBox:hidden').length != 0) {
                    jQuery('#loadMore').show();
                }
                jQuery('#loadMore').on('click', function (e) {
                    e.preventDefault();
                    jQuery('.js-moreBox:hidden').slice(0, 4).slideDown();
                    if (jQuery('.js-moreBox:hidden').length == 0) {
                        jQuery('#loadMore').fadeOut('slow');
                    }
                });
                setTimeout(function() {
                    jQuery('#loadMore').trigger('click');
                }, 500);
            }
        }
    };

    canett.items = {
        inspiration: {
            jElementContainer: null,
            data: window.jsonInspiration,
            init: function(){
                if(jQuery('.js-canett-inspiration').length > 0){
                    canett.items.inspiration.jElementContainer = jQuery('.js-canett-inspiration');
                    e4.require.js( e4.settings.require.handlebars, function () {
                        e4.handlebars.registerHelpers( 'compare' );
                        e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-items-inspiration-item' );
                        canett.items.inspiration.bindEvents();
                        canett.items.inspiration.buildList();
                    } );
                }
            },
            bindEvents: function(){
                canett.items.inspiration.jElementContainer.on('change', '.js-canett-select', function(event){
                    canett.items.inspiration.buildList();
                });
            },
            buildList: function(){
                var currentData = canett.items.inspiration.filteredData();
                jQuery( '.js-canett-inspiration-items' ).empty();
                jQuery.each(currentData, function(intIndex, item){
                    jQuery( '.js-canett-inspiration-items' ).append( e4.handlebars.tmpl.itemsInspirationItem( item ) );
                });
            },
            filteredData: function(){
                var currentDataItems = canett.items.inspiration.data.items;
                jQuery.each(currentDataItems, function(intIndex, item){
                    var intCssClassesIndex = intIndex % canett.items.inspiration.data.itemCss.length;
                    item.cssClasses = canett.items.inspiration.data.itemCss[intCssClassesIndex];
                    var intCssClassesWrapperIndex = intIndex % canett.items.inspiration.data.itemCssWrapper.length;
                    item.cssClassesWrapper = canett.items.inspiration.data.itemCssWrapper[intCssClassesWrapperIndex];
                });
                return currentDataItems;
            }
        }
    };

    canett.urlModel = {
        init: function () {
            console.log("test2")
            if( window.location.href.indexOf( 'modal=true' ) !== -1 ) {
                jQuery(window).on('load', function() {
                    // jQuery('body').addClass('modalstyle');
                    // jQuery('footer, header').remove();
                    jQuery('.js-e-canvas').prepend('<a class="btn" id="item-backlink"></a>');
                    jQuery("#item-backlink").click(function(event) {
                        event.preventDefault();
                        history.back();
                    });
                });
            }
        }
    };

    canett.lottie = {
        init: function () {
            jQuery( '.js-canett-lottie-container' ).each( function ( intIndex, domLottieContainer ){
                var jDomNode = jQuery( domLottieContainer ),
                    jLottiePlayer = jDomNode.find( '.js-canett-lottie-player' ),
                    domLottiePlayer = jLottiePlayer[0],
                    strLottiePath = jLottiePlayer.data( 'animationPath' ),
                    lottieAnimation = lottie.loadAnimation({
                        container: domLottiePlayer,
                        renderer: 'svg',
                        loop: false,
                        autoplay: false,
                        path: strLottiePath,
                    });

                jDomNode.on( 'mouseenter', function () {
                    lottieAnimation.setDirection( 1 );
                    lottieAnimation.setSpeed( 2 );
                    lottieAnimation.play();
                }).on( 'mouseleave', function () {
                    lottieAnimation.setDirection( -1 );
                    lottieAnimation.play();
                });

                if ( jDomNode.hasClass('is-inpath') ) {
                    lottieAnimation.setDirection( 1 );
                    lottieAnimation.setSpeed( 2 );
                    lottieAnimation.play();
                }

            });
        }
    };

    canett.hassub = {
        init: function () {
            jQuery('.e-content-article:has(.custom-submenu)').addClass('has_sub');
        }
    };

}() );
